import React, { useState } from "react";
import Title from "../../../components/Title/Title";
import { Col, Container, Row } from "react-bootstrap";
import EventCard from "../../../components/EventCard";
import Button from "../../../components/Button";
import SectionHeader from "../../../components/SectionHeader";
import RequestMoreInformation from "../../../components/RequestMoreInformation";
import "./Contact.scss";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { IoLogoFacebook, IoSend } from "react-icons/io5";

function Contact() {
  return (
    <>
      <div className="contact-us"></div>
      <div className="container-fluid2 bg2 ">
        <Title
          options={{ title: "Contact EFH | Online ICSE & CBSE Tuition Support", description: "Contact EFH (Education From Home) for help with our online Computer Science courses and tuition for ICSE and CBSE students of Class 9-12.", image: "", url: "" }}
        />

        <div className="container sectionheader ">
          <div className="row">
            <div className="col-md-7">
              <div className="card p-3">
                <h2
                  className="text-center fw-bold mb-4"
                  style={{ fontSize: "250%", lineHeight: "2" }}
                >
                  Get in touch with <span className="text-primary">EFH</span>
                </h2>

                <p className="text-muted">
                  <span className="fw-bold text-primary">
                    Get in Touch with EFH
                  </span>
                  <br />
                  Thank you for your interest in EFH! Whether you have questions
                  about our services, want to provide feedback, or simply want
                  to say hello, we'd love to hear from you.
                  <br />
                  <br />
                  <span className="fw-bold">Contact Information:</span>
                  <br />
                  <span className="text-primary">Email:</span>{" "}
                  {/* <a href="mailto:efhfromhome.prosper.india@gmail.com">efhfromhome.prosper.india@gmail.com</a> */}
                  <a href="mailto:efhdigitalminds@gmail.com">
                    efhdigitalminds@gmail.com
                  </a>
                  <br />
                  <span className="text-primary">WhatsApp:</span>{" "}
                  <a
                    aria-label="Chat on WhatsApp"
                    href="https://wa.me/7895926600"
                    target="_blank"
                  >
                    {" "}
                    789-5926-600
                  </a>
                  <br />
                  <span className="text-primary">Address:</span> EFH Tech
                  Service LLP 13/2 New Road, Opposite MKP College, Dehradun,
                  Uttarakhand, 248001
                  <br />
                  <br />
                  <span className="fw-bold">Our Office Hours:</span>
                  <br />
                  Monday - Friday: 9:00 AM to 5:00 PM (Local Time)
                  <br />
                  <br />
                  <span className="fw-bold">Social Media:</span>
                  <br />
                  Stay connected with us on social media for updates,
                  announcements, and educational content:
                  <br />
                  <a
                    href="https://www.facebook.com/profile.php?id=61574141350108"
                    target="_blank"
                  >
                    {/* <IoLogoFacebook className=" me-2" size={24} />{" "} */}
                    <FaFacebook size={24} />
                  </a>
                  <span> | </span>
                  <a
                    href="https://www.instagram.com/education.from.home/"
                    target="_blank"
                  >
                    <FaInstagram size={24} />
                  </a>
                  <span> | </span>
                  <a
                    href="https://www.linkedin.com/in/efh-education-from-home-8416b03a4/"
                    target="_blank"
                  >
                    <FaLinkedin className="text-primary" size={24} />
                    {/* LinkedIn */}
                  </a>
                  <br />
                  <br />
                  <span className="fw-bold">Visit Us:</span>
                  <br />
                  Feel free to visit us at our office during our working hours.
                  We're always happy to meet our students and partners in
                  person!
                  <br />
                  <br />
                  <span className="fw-bold">Feedback:</span>
                  <br />
                  Your feedback is valuable to us. If you have any suggestions,
                  comments, or ideas for improvement, please don't hesitate to
                  reach out. We're committed to providing the best learning
                  experience for our students, and your input helps us achieve
                  that goal.
                  <br />
                  <br />
                  We look forward to hearing from you!
                </p>
              </div>
            </div>
            <div className="col-md-5">
              <div className=" border p-5" style={{ backgroundColor: "#ffff" }}>
                <h2
                  className="text-center fw-bold mb-4"
                  style={{ fontSize: "250%", lineHeight: "2" }}
                >
                  Contact <span className="text-primary">Efh</span>
                </h2>
                <RequestMoreInformation />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
